import { render } from "./receivedPackage.vue?vue&type=template&id=a5bd95a8&scoped=true"
import script from "./receivedPackage.vue?vue&type=script&lang=js"
export * from "./receivedPackage.vue?vue&type=script&lang=js"

import "./receivedPackage.vue?vue&type=style&index=0&id=a5bd95a8&lang=scss&scoped=true"
import "./receivedPackage.vue?vue&type=style&index=1&id=a5bd95a8&lang=scss"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5bd95a8"]])

export default __exports__